import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { FaStar, FaArrowRight } from 'react-icons/fa';

const Offers: React.FC = () => {
  const offers = [
    {
      id: 'circusbet',
      name: 'CircusBet',
      bonus: '100€ de bonus',
      rating: 4.8,
      image: '/images/offers/circusbet.webp',
      description: 'Bookmaker français de confiance avec retraits rapides et excellent service client',
      url: 'https://www.circusbet.fr/',
    },
    {
      id: 'genybet',
      name: 'GenyBet',
      bonus: '200€ de bonus',
      rating: 4.9,
      image: '/images/offers/genybet.webp',
      description: 'Expérience premium avec programme VIP exclusif et cotes compétitives',
      url: 'https://www.genybet.fr/',
    },
    {
      id: 'netbet',
      name: 'NetBet',
      bonus: '150€ de bonus',
      rating: 4.7,
      image: '/images/offers/netbet.webp',
      description: 'Paris sportifs et casino sur une plateforme fiable et sécurisée',
      url: 'https://www.netbet.fr/',
    },
  ];

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Bookmakers Français',
    description: 'Découvrez tous les bookmakers français disponibles et leurs offres',
    url: 'https://parisportfrance.com/offers',
  };

  return (
    <>
      <SEO
        title="Tous les Bookmakers Français"
        description="Découvrez tous les bookmakers français disponibles, leurs bonus et promotions. Comparez les offres et trouvez le bookmaker parfait pour vous."
        url="/offers"
        schema={schema}
      />

      <div className="pt-24 md:pt-32 pb-20 min-h-screen bg-dark-bg">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Tous les Bookmakers</h1>
            <p className="text-gray-400 text-lg">
              Comparez les meilleurs bonus de bookmakers français et trouvez celui qui vous convient
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {offers.map((offer) => (
              <div
                key={offer.id}
                className="bg-dark-card border border-dark-border rounded-xl p-6 hover:border-yellow-400 transition-all"
              >
                <img
                  src={offer.image}
                  alt={offer.name}
                  className="w-full h-48 object-contain rounded-lg mb-4 p-5"
                  loading="lazy"
                />
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-2xl font-bold text-white">{offer.name}</h3>
                  <div className="flex items-center space-x-1">
                    <FaStar className="text-yellow-400" />
                    <span className="text-white font-semibold">{offer.rating}</span>
                  </div>
                </div>
                <div className="text-yellow-400 font-semibold text-lg mb-3">
                  {offer.bonus}
                </div>
                <p className="text-gray-400 mb-6">{offer.description}</p>
                {offer.url ? (
                  <a
                    href={offer.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full text-center px-6 py-3 bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-dark-bg rounded-lg font-semibold transition-all"
                  >
                    Voir l'offre
                  </a>
                ) : (
                  <Link
                    to={`/offers/${offer.id}`}
                    className="block w-full text-center px-6 py-3 bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-dark-bg rounded-lg font-semibold transition-all"
                  >
                    Voir les détails
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Offers;

